/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    Paper,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from '@material-ui/core';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { getDisplayDate } from '../../../../../shared-functions';
import { OpenModal, openModalAction } from '../../../../../form-modal/actions';
import { UpdateFormDetails, updateFormDetailsAction } from '../actions/update-form-details';
import { getClaim } from '../../../../../claim';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Nullable } from '../../../../../shared-types';
import { ClaimType } from '../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
    updateFormDetails?: UpdateFormDetails;
    claimType?: Nullable<ClaimType>;
}

interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const employmentHistoryView: React.FC<Props> = ({
    classes,
    openModal,
    formDetails,
    updateFormDetails,
    disableEditButton,
    claimType,
}: Props) => {
    const employment = formDetails?.employment;
    const history = employment?.employmentHistory ?? [];

    return (
        <>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Employment History
                    </Typography>
                </Grid>
            </Grid>

            <Paper className={classes.paper}>
                {/* EMPLOYMENT HISTORY */}
                <Grid container spacing={2} className={classes.marginTop2}>
                    {history.map((h, index) => (
                        <ExpansionPanel key={index} style={{ width: '100%' }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel-content-${index}`}
                                id={`panel-header-${index}`}
                            >
                                <Typography>{`Occupation ${index + 1}`}</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <LabeledValue
                                            label="Employer Name"
                                            value={
                                                claimType === ClaimType.Retrenchment
                                                    ? h.employerName
                                                    : h.companyName
                                            }
                                        />
                                    </Grid>
                                    {claimType === ClaimType.Retrenchment && (
                                        <>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <LabeledValue
                                                    label="Contact number"
                                                    value={h.contactNumber}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <LabeledValue
                                                    label="Email Address"
                                                    value={h.emailAddress}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <LabeledValue
                                                    label="Date employed from"
                                                    value={getDisplayDate(h.dateEmployedFrom)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <LabeledValue
                                                    label="Date employed to"
                                                    value={getDisplayDate(h.dateEmployedTo)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <LabeledValue
                                                    label="Number of years in service"
                                                    value={h.yearsInService}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                    {claimType !== ClaimType.Retrenchment && (
                                        <>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <LabeledValue
                                                    label="Nature of Occupation"
                                                    value={h.natureOfOccupation}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <LabeledValue
                                                    label="Start Date"
                                                    value={getDisplayDate(h.startDate)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <LabeledValue
                                                    label="End Date"
                                                    value={getDisplayDate(h.endDate)}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    ))}
                </Grid>
            </Paper>
        </>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails ?? getFormDetails(state),
    disableEditButton: ownProps.disableEditButton ?? false,
    updateFormDetails: ownProps.updateFormDetails ?? updateFormDetailsAction,
    claimType: getClaim(state).claimType,
});

const mapDispatchToProps = {
    openModal: openModalAction,
    updateFormDetails: updateFormDetailsAction,
};

export const EmploymentHistoryView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(employmentHistoryView));
